export default function Footer() {
    return (
      <footer className="border-t border-border bg-white">
        <div className="w-full px-4 md:px-6 lg:px-8 py-6">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div className="text-sm text-muted">
              © {new Date().getFullYear()} ThePulseCare. All rights reserved.
            </div>
  
            <div className="flex flex-wrap items-center gap-4 text-sm">
              <button className="text-muted hover:text-text">Privacy</button>
              <button className="text-muted hover:text-text">Terms</button>
              <button className="text-muted hover:text-text">Support</button>
              <span className="text-muted">v0.1</span>
            </div>
          </div>
        </div>
      </footer>
    );
  }
  